<template>
  <div>
    <crumb-tit>
      <span slot="breadTit">{{ $t('message["609"]') }}</span>
      <span slot="secondTit">{{ $t('message["609"]') }}</span>
    </crumb-tit>
    <div class="alloication-tip-t">
      <a-alert
        :message="alertTipTxt"
        type="warning"
        show-icon
      />
    </div>
    <div
      v-if="datasReady"
      class="notice-setting-box"
    >
      <a-tabs
        v-model="activeName"
        :animated="false"
        @change="handleClick"
      >
        <a-tab-pane
          v-for="item in datas"
          :key="item.roleid"
          :tab="item.rolename"
        >
          <main-list :item-data="item" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import CrumbTit from '@/components/pc/config/CrumbTit'
import MainList from './listset/MainList'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  components: {
    CrumbTit,
    MainList
  },
  inject: ['reload'],
  data () {
    return {
      activeName: 'system'
    }
  },
  computed: {
    ...mapState('config/setlist', ['datasReady', 'datas']),
    alertTipTxt () {
      return this.$t('message["1179"]')
    }
  },
  async created () {
    const chain = await this.getlistRolesDatas()
    chain.onSuccess(raw => {
      if (raw.length) {
        this.activeName = raw[0].roleid
        this.getMenuDatas({ roleid: this.activeName, system_role: raw[0].system_role })
        this.setActiveMenuData(raw[0])
      }
    })
      .fetch()
  },
  methods: {
    ...mapMutations('config/setlist', ['setActiveMenuData']),
    ...mapActions('config/setlist', ['getlistRolesDatas', 'getlistmenuDatas']),
    handleClick (e) {
      const { datas } = this
      const activeData = datas.filter(item => item.roleid === e)[0]
      this.getMenuDatas({ roleid: e, system_role: activeData.system_role })
      this.setActiveMenuData(activeData)
    },
    async getMenuDatas (params) {
      const chain = await this.getlistmenuDatas()
      chain.params(params)
        .onSuccess(raw => {
          // console.log(raw)
        })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
  .notice-setting-box::v-deep {
    font-size: 18px;
    margin-top: 16px;
    .ant-tabs-bar {
      border-bottom: none 0;
    }
    .ant-tabs-nav .ant-tabs-tab {
      font-size: 18px;
      font-weight: bold;
      padding: 12px 0;

    }
  }
  .alloication-tip-t::v-deep {
    margin-top: 24px;
    .ant-alert-warning{
      background: #FFF4E7;
      border: 1px solid #F6A953;
      border-radius: 4px;
    }
  }
</style>
